"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.popoverConfig = exports.intialValuesConfig = exports.idPrefix = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'business';
var idPrefix = exports.idPrefix = "bv_";
var popoverConfig = exports.popoverConfig = {
  serviceText: 'Businesses that provide expertise and labor in the form of employees, such as accountants, attorneys, architects, and medical practitioners.',
  nonServiceText: 'Businesses that provide tangible goods to the marketplace, such as retailers, wholesalers, and manufacturers.'
};
var propsConfig = exports.propsConfig = {
  config: {
    HasBorder: true,
    Icon: 'icon-agency-black',
    Label: 'Business Value',
    Steps: [{
      Title: 'What is my business worth?',
      Description: '',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'My Business',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: '',
        Side: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'My Business Ownership',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Calculate',
        Icon: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Your Results',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next step',
        Description: 'Discuss your results with a financial professional today.',
        CTAList: [{
          Label: 'Contact a Financial Professional',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Business Owner Resources',
          Href: 'https://www.massmutual.com/business/business-owners',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};
var validationConfigPage1 = yup.object().shape({
  ownersAvePrior3YearsAmount: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  businessProfitAvePrior3YearsAmount: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  netBookAmount: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000')
});
var validationConfigPage2 = yup.object().shape({
  businessPercent: yup.number().transform(parseFloat).required('Must be between 0 and 100 % and to a maximum of 2 decimal places').min(0, 'Must be between 0 and 100 % and to a maximum of 2 decimal places').max(100, 'Must be between 0 and 100 % and to a maximum of 2 decimal places')
});
var validationModal = validationConfigPage1.concat(validationConfigPage2);
var validationConfig = exports.validationConfig = [validationConfigPage1, validationConfigPage2, validationModal];
var intialValuesConfig = exports.intialValuesConfig = {
  ownersAvePrior3YearsAmount: '',
  businessProfitAvePrior3YearsAmount: '',
  netBookAmount: '',
  businessPercent: '',
  isService: ''
};